import { Button, Image, Input, message, Select, Upload, Form, Row, Col, Card } from 'antd';
import React, { useEffect, useState } from 'react';
import InputField from '../../../components/InputField/InputField';
import { UploadOutlined } from '@ant-design/icons';
import { businessCategories, entityType } from '../../../config/variable';
import { getAllPlansIn, getUsersIn } from '../../../api/functions';
import { createFrnachise } from '../../../api/franchise';

const { Option } = Select;
const { TextArea } = Input;

const AddFranchise = ({
  setAddFranchiseModal
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    businessName: "",
    gstNumber: "",
    entityType: "",
    businessCategory: "",
    address: "",
    street: "",
    city: "",
    country: "",
    state  :"",
    postalCode: "",
    businessOverview: "",
    businessPhotoUrl: "",
    logoPhotoUrl: "",
    franchiseFee: "",
    royalPercentage: "",
    requiredAreaSqFt: "",
    supportProvided: "",
    territoryAvailability: "",
    minimumInvestmentRequired: "",
    maximumInvestmentRequired: "",
    expectedROI: "",
    loanAssistanceOptions: "",
    acceptanceOfTermsAndConditions: true,
    agreementToPrivacyPolicy: true,
    user: "",
    plan: "",
    payment_status: "",
    status: "pending",
    madeBy: "Admin"
  });
  const [users, setAllUsers] = useState([]);
  const [plans, setAllPlans] = useState([]);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateError = () => {
    let errObj = {};
    if (!formData?.businessName) errObj.businessName = "Business Name is required";
    if (!formData?.gstNumber) errObj.gstNumber = "GST number is required.";
    if (!formData?.entityType) errObj.entityType = "Entity Type is required.";
    if (!formData?.businessCategory) errObj.businessCategory = "Business Category is required.";
    if (!formData?.address) errObj.address = "Address is required";
    if (!formData?.street) errObj.street = "Street is required";
    if (!formData?.city) errObj.city = "City is required";
    if (!formData?.country) errObj.country = "Country is required.";
    if (!formData?.state) errObj.state = "State is required.";
    if (!formData?.postalCode) errObj.postalCode = "Postal Code is required.";
    if (!formData?.businessOverview) errObj.businessOverview = "Business Overview is required";
    if (!formData?.businessPhotoUrl) errObj.businessPhotoUrl = "Business Photo Url is required";
    if (!formData?.logoPhotoUrl) errObj.logoPhotoUrl = "Logo Photo Url is required";
    if (!formData?.franchiseFee) errObj.franchiseFee = "Franchise Fee is required";
    if (!formData?.royalPercentage) errObj.royalPercentage = "Royal Percentage is required";
    if (!formData?.requiredAreaSqFt) errObj.requiredAreaSqFt = "Required area square feet";
    if (!formData?.supportProvided) errObj.supportProvided = "Support Provided is required";
    if (!formData?.territoryAvailability) errObj.territoryAvailability = "Territory Availability is required.";
    if (!formData?.minimumInvestmentRequired) errObj.minimumInvestmentRequired = "Minimum investment is required";
    if (!formData?.maximumInvestmentRequired) errObj.maximumInvestmentRequired = "Maximum investment is required";
    if (!formData?.expectedROI) errObj.expectedROI = "Expected ROI is required";
    if (!formData?.loanAssistanceOptions) errObj.loanAssistanceOptions = "Loan Assistance option is required.";
    if (!formData?.acceptanceOfTermsAndConditions) errObj.acceptanceOfTermsAndConditions = "Acceptance of terms and condition is required";
    if (!formData?.agreementToPrivacyPolicy) errObj.agreementToPrivacyPolicy = "Agreement to privacy policy is required";
    if (!formData?.status) errObj.status = "Status is required";
    console.log('the error obj',errObj)
    setErrors(errObj);
    return Object.keys(errObj).length === 0;
  };

  const handleSubmit = async () => {
    try {
    
      if (!validateError()) {
        message.error('Please fill all the required fields.');
        return;
      }
      console.log('ok2')
      if (formData?.gstNumber && formData?.gstNumber.length !== 15) {
        setErrors({
          gstNumber: "GST Number should be 15 digits long"
        });
        return;
      }


      if (formData?.minimumInvestmentRequired > formData?.maximumInvestmentRequired) {
        
          message.error("Minimum investment must be less than maximum investment.")
        return;
      }
      
      setLoading(true);

      await createFrnachise({
        ...formData
      })
      setAddFranchiseModal(false);


      message.success('Franchise submitted successfully!');
    } catch (e) {
      console.log(e);
      message.error(e.response?.data?.message || 'Franchise creation failed.');
    } finally {
      setLoading(false);
    }
  };

  const handleBusinessPhotoUrlChange = (e) => {
    let file = e.fileList[0]?.originFileObj;
    if (file.size > 500 * 1000) {
      message.error("File must not be more than 500kb.");
      return;
    }
    if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
      message.error("Only .jpg and .png files are allowed.");
      return;
    }
    setFormData({
      ...formData,
      businessPhotoUrl: file
    });
  };

  const handleLogoPhotoUrl = (e) => {
    let file = e.fileList[0]?.originFileObj;
    if (file.size > 500 * 1000) {
      message.error("File must not be more than 500kb.");
      return;
    }
    if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
      message.error("Only .jpg and .png files are allowed.");
      return;
    }
    setFormData({
      ...formData,
      logoPhotoUrl: file
    });
  };

  const getAllPlans = async () => {
    try {
      const response = await getAllPlansIn();
      setAllPlans(response?.data?.plans?.filter((item) => item.planType ==='Franchise'));
    } catch (e) {
      console.log(e);
    }
  }

  const getAllUsers = async () => {
    try {
      const response = await getUsersIn();
      setAllUsers(response.data.users);
    } catch (e) {
      console.log(e);
  }
}
  useEffect(() => {
    getAllUsers();
    getAllPlans();
  
},[])



  

  return (
    <Card title="Add Franchise" style={{ margin: '20px' }}>
      <Form layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <InputField
              name="businessName"
              type="text"
              placeholder="Enter Business Name"
              formData={formData}
              handleInputChange={handleInputChange}
              label="Business Name"
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <Form.Item label="Upload Business Photo" required>
              <Upload
                beforeUpload={() => false}
                onChange={handleBusinessPhotoUrlChange}
                maxCount={1}
                showUploadList={false}
                accept=".jpg,.png"
              >
                <Button icon={<UploadOutlined />}>Upload Business Photo</Button>
              </Upload>
        

                {
                errors && errors.businessPhotoUrl &&
                <div
                    style={{
                      color: "red"
                    }}
                >
                
                  {
                    errors?.businessPhotoUrl
                  }</div>
              }
              
              {formData?.businessPhotoUrl && (
                <Image
                  width={100}
                  src={URL.createObjectURL(formData.businessPhotoUrl)}
                  style={{ marginTop: '10px' }}
                />
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Upload Logo" required>
              <Upload
                beforeUpload={() => false}
                onChange={handleLogoPhotoUrl}
                maxCount={1}
                showUploadList={false}
                accept=".jpg,.png"
              >
                <Button icon={<UploadOutlined />}>Upload Logo Photo</Button>
              </Upload>
              {
                errors && errors.logoPhotoUrl && <div
                  style={{
                    color: "red"
                  }}
                >
                  {
                    errors?.logoPhotoUrl
                  }</div>
              }
              {formData?.logoPhotoUrl && (
                <Image
                  width={100}
                  src={URL.createObjectURL(formData.logoPhotoUrl)}
                  style={{ marginTop: '10px' }}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Select Entity Type" required>
              <Select
                name="entityType"
                onChange={(value) => setFormData(prev => ({ ...prev, entityType: value }))}
                placeholder="Select Entity Type"
              >
                {entityType.map((item) => (
                  <Option key={item} value={item}>{item}</Option>
                ))}
              </Select>
              {errors.entityType && <div style={{ color: 'red' }}>{errors.entityType}</div>}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Select Business Category" required>
              <Select
                name="businessCategory"
                onChange={(value) => setFormData(prev => ({ ...prev, businessCategory: value }))}
                placeholder="Select Business Category"
              >
                {businessCategories.map((item) => (
                  <Option key={item} value={item}>{item}</Option>
                ))}
              </Select>
              {errors.businessCategory && <div style={{ color: 'red' }}>{errors.businessCategory}</div>}
            </Form.Item>
          </Col>
          <Col span={12}>
            <InputField
              name="gstNumber"
              type="text"
              placeholder="Enter GST Number"
              formData={formData}
              handleInputChange={handleInputChange}
              label="GST Number"
              errors={errors}
            />
          </Col>
        </Row>



        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Payment Status" required>
              <Select
                name="payment_status"
                onChange={(value) => setFormData(prev => ({ ...prev, payment_status: value }))}
                placeholder="Select Payment Status"
              >
               <Option value ="paid">Paid </Option>
               <Option value ="unpaid">Unpaid </Option>
              </Select>
              {errors.businessCategory && <div style={{ color: 'red' }}>{errors.businessCategory}</div>}
            </Form.Item>
          </Col>
          {/* <Col span={12}>
            <Form.Item label="Status" required>
              <Select
                name="status"
                onChange={(value) => setFormData(prev => ({ ...prev, status: value }))}
                placeholder="Select Status"
              >
                ["pending", "accepted", "rejected"],
                <Option value="pending">Pendnig</Option>
                <Option value="accepted">Unpaid </Option>
                <Option value="rejected">Unpaid </Option>
              </Select>
              {errors.businessCategory && <div style={{ color: 'red' }}>{errors.businessCategory}</div>}
            </Form.Item>
          </Col> */}
        </Row>



        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Select User">
              <Select
                showSearch
                name="businessCategory"
                onChange={(value) => setFormData(prev => ({ ...prev, user: value }))}
                placeholder="Select User"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
                }
              >
                {users.map((item) => (
                  <Option key={item?._id} value={item?._id}>
                    {item?.name}

                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Select Plan">
              <Select
                showSearch
                name="plan"
                onChange={(value) => setFormData(prev => ({ ...prev, plan: value }))}
                placeholder="Select Plan"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
                }
              >
                {plans.map((item) => (
                  <Option key={item?._id} value={item?._id}>
                    {item?.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>



        <Row gutter={16}>
          <Col span={12}>
            <InputField
              name="address"
              type="text"
              placeholder="Enter Address"
              formData={formData}
              handleInputChange={handleInputChange}
              label="Address"
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <InputField
              name="street"
              type="text"
              placeholder="Enter Street"
              formData={formData}
              handleInputChange={handleInputChange}
              label="Street"
              errors={errors}
            />
          </Col>
          <Col span={8}>
            <InputField
              name="state"
              type="text"
              placeholder="Enter State"
              formData={formData}
              handleInputChange={handleInputChange}
              label="State"
              errors={errors}
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <InputField
              name="city"
              type="text"
              placeholder="Enter City"
              formData={formData}
              handleInputChange={handleInputChange}
              label="City"
              errors={errors}
            />
          </Col>
          <Col span={8}>
            <InputField
              name="country"
              type="text"
              placeholder="Enter Country"
              formData={formData}
              handleInputChange={handleInputChange}
              label="Country"
              errors={errors}
            />
          </Col>
          <Col span={8}>
            <InputField
              name="postalCode"
              type="text"
              placeholder="Enter Postal Code"
              formData={formData}
              handleInputChange={handleInputChange}
              label="Postal Code"
              errors={errors}
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Business Overview" required>
              <TextArea
                name="businessOverview"
                placeholder="Enter Business Overview"
                value={formData.businessOverview}
                onChange={handleInputChange}
                rows={4}
              />
              {errors.businessOverview && <div style={{ color: 'red' }}>{errors.businessOverview}</div>}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <InputField
              name="franchiseFee"
              type="number"
              placeholder="Enter Franchise Fee"
              formData={formData}
              handleInputChange={handleInputChange}
              label="Franchise Fee"
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <InputField
              name="royalPercentage"
              type="number"
              placeholder="Enter Royal Percentage"
              formData={formData}
              handleInputChange={handleInputChange}
              label="Royal Percentage"
              errors={errors}
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <InputField
              name="requiredAreaSqFt"
              type="number"
              placeholder="Enter Required Area (Sq. Ft)"
              formData={formData}
              handleInputChange={handleInputChange}
              label="Required Area (Sq. Ft)"
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <InputField
              name="supportProvided"
              type="text"
              placeholder="Enter Support Provided"
              formData={formData}
              handleInputChange={handleInputChange}
              label="Support Provided"
              errors={errors}
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <InputField
              name="territoryAvailability"
              type="text"
              placeholder="Enter Territory Availability"
              formData={formData}
              handleInputChange={handleInputChange}
              label="Territory Availability"
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <InputField
              name="minimumInvestmentRequired"
              type="number"
              placeholder="Enter Minimum Investment Required"
              formData={formData}
              handleInputChange={handleInputChange}
              label="Minimum Investment Required"
              errors={errors}
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <InputField
              name="maximumInvestmentRequired"
              type="number"
              placeholder="Enter Maximum Investment Required"
              formData={formData}
              handleInputChange={handleInputChange}
              label="Maximum Investment Required"
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <InputField
              name="expectedROI"
              type="number"
              placeholder="Enter Expected ROI"
              formData={formData}
              handleInputChange={handleInputChange}
              label="Expected ROI"
              errors={errors}
            />
          </Col>
        </Row>


        <Row gutter={16}>
          <Col span={12}>
            <InputField
              name="loanAssistanceOptions"
              type="text"
              placeholder="Enter Loan Assistance Options"
              formData={formData}
              handleInputChange={handleInputChange}
              label="Loan Assistance Options"
              errors={errors}
            />

          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <Button type="primary" onClick={handleSubmit} style={{ width: '100%',marginTop :"20px"}}>
              {
                loading ? "Loading..." : "Submit"
           }
              
            </Button>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default AddFranchise;